import React, { useState } from "react";
import Section from "@atoms/Section/Section";
import Title from "@atoms/Title/Title";
import TitleGroup from "@atoms/TitleGroup/TitleGroup";
import Module from "@atoms/Module/Module";
import CardSlider from "@components/CardSlider/CardSlider";
import Icon from "@atoms/Icon/Icon";
import { SwiperSlide } from "swiper/react";
import "./CardSliderWithImageBackground.scss";
import { AiOutlinePlusCircle } from "react-icons/ai";
import MarkdownText from "@atoms/MarkdownText/MarkdownText";
import GatsbyResponsiveImage from "@atoms/GatsbyResponsiveImage/GatsbyResponsiveImage";
import { ImageRenderType } from "@atoms/ResponsiveSharpImg/ResponsiveSharpImg";

const CardSliderWithImageBackground = ({ title, subtitle, components }) => {
	const data = components ? components[0] : undefined;
	const cards = data ? data?.component : [];

	const [flippingCard, setFlippingCard] = useState<string | null>(null);

	const onFlip = (itemId: string) => {
		setFlippingCard(itemId === flippingCard ? null : itemId);
	};

	return (
		<>
			<Section
				spacing="s"
				container="large"
				className="CardSliderWithImageBackground"
			>
				<TitleGroup align="left" title={title} subtitle={subtitle} />
				<CardSlider
					sliderName="CardSliderWithImageBackground"
					hasNavigation
					hideOverflow
					sliderOption={{
						autoHeight: true,
						observer: true,
						observeParents: true,
						preventClicks: true,
						a11y: false,
						preventClicksPropagation: true,
						threshold: 20,
						slidesPerView: 1.3,
						breakpoints: {
							slidesOffsetAfter: 20,
							slidesOffsetBefore: 20,
							501: {
								slidesPerView: 1.3,
								spaceBetween: 16,
							},
							801: {
								slidesPerView: 2.3,
								spaceBetween: 16,
							},
							1001: {
								slidesPerView: 3.3,
							},
						},
					}}
				>
					{cards.map((item: any) => {
						const isFlip = item.id === flippingCard;
						return (
							<SwiperSlide key={`CardSlider_${item.id}`}>
								<div
									onClick={() => onFlip(item.id)}
									className={`CardSliderWithImageBackground--wrapper ${
										isFlip ? "flip" : ""
									}`}
								>
									<div
										className={`CardSliderWithImageBackground--card `}
										style={
											item.images?.length
												? undefined
												: {
														background:
															"linear-gradient(5.67deg,#516253 9.7%,rgba(81, 98, 83, 0) 85.12%)",
													}
										}
									>
										<GatsbyResponsiveImage
											url={item.images[0].src?.url}
											urlSharp={item.images[0].src?.urlSharp}
											altText={item.title}
											type={ImageRenderType.Img}
										/>
										<Module radius="giant" spacing="m">
											<Title
												size="l"
												theme="white"
												className="CardSliderWithImageBackground--quote"
											>
												{item.quote}
											</Title>
											<Icon
												icon={<AiOutlinePlusCircle />}
												theme="white"
												size="xl"
												className="cursor-pointer"
											/>
										</Module>
									</div>
									<div className="CardSliderWithImageBackground--cardBack">
										<Module radius="giant" spacing="m">
											<Title size="s">{item.title}</Title>
											<MarkdownText content={item.content} />
											<Icon
												icon={<AiOutlinePlusCircle />}
												size="xl"
												theme="action"
												className="cursor-pointer"
												onClick={() => onFlip(undefined)}
											/>
										</Module>
									</div>
								</div>
							</SwiperSlide>
						);
					})}
				</CardSlider>
			</Section>
		</>
	);
};

export default CardSliderWithImageBackground;
